import {DEMO_DATA_STAGE_SET, LOADING_SET, SHOW_EXTERNAL_CONTENT_SET, SIZE_SET, URL_SET} from './actionTypes'
import {createAction} from "redux-actions"
import {DemoDataStageType} from './constants'
import makeRpcCall from '../../util/jquery_rpc'
import {getFirstName} from '../../loggedInUser/selectors'
import {getDemoDataStage, getLoadExternalWelcomeScreen, getShowExternalContent} from './selectors'
import {BASE_PATH} from '../../constants'
import rpcCall from '../../util/rpc/rpcCalls'
import {createRelativeLink} from '../../panels/urlHelper/utils'
import PageOverlayTipsManager from '../../tips/PageOverlayTipsManager'

export const setLoading = createAction(LOADING_SET)
export const setShowExternalContent = createAction(SHOW_EXTERNAL_CONTENT_SET)
export const setDemoDataStage = createAction(DEMO_DATA_STAGE_SET)
export const setUrl = createAction(URL_SET)
export const setSize = createAction(SIZE_SET)

const setDemoDataLoadingStage = dispatch => {
    dispatch(setLoading(false))
    dispatch(setShowExternalContent(false))
    dispatch(setDemoDataStage(DemoDataStageType.ACTIVE))
}

export const openLightbox = () => (dispatch, getState) => {
    PageOverlayTipsManager.getInstance().enableCookie()
    PageOverlayTipsManager.getInstance().enableFirstTimeCookie()
    PageOverlayTipsManager.getInstance().enableShowLater()

    dispatch(setLoading(true))

    if (getLoadExternalWelcomeScreen(getState())) {
        dispatch(loadExternalContent())
    } else {
        dispatch(loadInternalContent())
    }
}

const loadInternalContent = () => dispatch => {
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//"
                                 + window.location.hostname
                                 + (window.location.port ? ':' + window.location.port : '')
    }
    dispatch(loadContent(createRelativeLink('user/w.do')))
}

const loadExternalContent = () => dispatch => {
    rpcCall(
        'WelcomeScreenService.getExternalContentUrl',
        [],
        () => {
            dispatch(checkAndLoadDemoData)
            return true
        }
    ).then(result => dispatch(loadContent(result)))
}

const loadContent = url => (dispatch, getState) => {
    dispatch(setUrl(url))
    window.setTimeout(() => {
            if (!getShowExternalContent(getState()) && getDemoDataStage(getState()) === DemoDataStageType.IDLE) {
                dispatch(checkAndLoadDemoData)
            }
        },
        10000)
}

export const sendMessage = contentKey => (dispatch, getState) => {
    //if we try to send a message too late (when time is out) then do nothing
    if (getDemoDataStage(getState()) !== DemoDataStageType.IDLE) {
        return
    }
    const win = window.frames[contentKey]
    win.postMessage({userName: getFirstName(getState())}, '*')
    window.addEventListener('message', event => {
        if (event.data.loaded
            && !getShowExternalContent(getState())
            && getDemoDataStage(getState()) === DemoDataStageType.IDLE) {
            dispatch(setSize({
                width: event.data.width,
                height: event.data.height,
            }))
            dispatch(setShowExternalContent(true))
            dispatch(setLoading(false))
        }
        if (event.data.closeFrame) {
            dispatch(closeLightbox())
        }
    })
}

const loadDemoData = dispatch => {
    dispatch(setDemoDataLoadingStage)
    const errorHandler = () => {
        dispatch(setDemoDataStage(DemoDataStageType.ERROR))
        return true
    }

    rpcCall(
        'DemoDataService.loadDemoData',
        [],
        errorHandler,
    ).then(() => {
        dispatch(setDemoDataStage(DemoDataStageType.COMPLETED))
        window.location.href = BASE_PATH
    })
}

const checkAndLoadDemoData = dispatch => {
    const closeWelcomeScreen = () => {
        dispatch(setShowExternalContent(false))
        dispatch(setLoading(false))
        PageOverlayTipsManager.getInstance().showFirstTimeTips()
        return true
    }
    rpcCall(
        'DemoDataService.isNeedToLoadDemoData',
        [],
        closeWelcomeScreen,
    ).then(result => {
        if (result === true) {
            dispatch(loadDemoData)
        } else {
            closeWelcomeScreen()
        }
        dispatch(setUrl(''))
        dispatch(setSize({width: 0, height: 0}))
    })
}

export const closeLightbox = () => dispatch => {
    makeRpcCall(
        'WelcomeScreenService.setCurrentUserSeenWelcomeScreen',
        []
    )
    dispatch(checkAndLoadDemoData)
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/actions.js